import { useState, forwardRef } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';
import ContactOptions from '@Components/Contact/ContactOptions';
import { ThemedButton } from '@Components/MuiWrappers/Button';
import useKeyPress from '@Components/Utilities/KeyPress';

const CollapsibleContacts = forwardRef((props, ref) => {
    const toggleID = ('collapse-button-' + (props.Id || props.PartID));
    const [showCollapsibleButtons, setShowCollapsibleButtons] = useState(false);
    const toggleCollapsibleButtons = () => setShowCollapsibleButtons(!showCollapsibleButtons);

    useKeyPress('Enter', toggleCollapsibleButtons, ref, toggleID);

    return (props.UseCollapsibleContact ?
        <div className='collapsible-contact-wrapper'>
            {props.isDetailPage ?
                <ThemedButton sx={{width: '100%', justifyContent: 'space-between'}} ref={(element) => { ref.current[toggleID] = element }} id={toggleID} className='collapsible-contact__button' onClick={toggleCollapsibleButtons} aria-expanded={showCollapsibleButtons}>
                    <i className='fas fa-share-alt' aria-hidden='true' />
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.contactus' />
                    {showCollapsibleButtons ?
                        <i className='fas fa-minus' aria-hidden='true' />
                        :
                        <i className='fas fa-plus' aria-hidden='true' />}
                </ThemedButton>
                :
                <a ref={(element) => { ref.current[toggleID] = element }} id={toggleID} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleCollapsibleButtons(); } }} tabIndex={0} role='button' className={'contact-btn' + (showCollapsibleButtons ? ' contact-btn-active' : '')} onClick={toggleCollapsibleButtons} aria-expanded={showCollapsibleButtons} >
                    <i className='fas fa-share-alt' aria-hidden='true' />
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.contactus' />
                </a>}
            {showCollapsibleButtons &&
                <div className={'collapsible-content collapsible-contact__list ' + (props.isDetailPage ? 'collapsible-contact__list_detail' : '')}>
                    <ContactOptions ref={ref} {...props} />
                </div>}
        </div>
        :
        <ContactOptions ref={ref} {...props} />
    );
});

export default CollapsibleContacts;